var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 25.3333C6.72416 25.224 6.78163 25.1237 6.8391 25.0235C7.73565 23.4287 9.18393 22.0527 11.4598 20.9956C13.4713 20.0661 15.7012 19.7745 18.092 20.1755C19.2874 20.385 20.3334 20.7405 21.2759 21.2234C21.8966 21.5424 22.4713 21.916 23 22.3443C24.023 23.1645 24.7816 24.0575 25.3334 25.0235",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9354 8.69702C20.1506 6.73853 18.2495 5.34436 16.0719 5.33329C13.0875 5.32223 10.6889 7.69011 10.6668 10.6444C10.6447 13.5877 13.0544 15.9888 16.0277 15.9999C18.2274 16.0109 20.1506 14.6057 20.9465 12.6472C21.1897 12.0386 21.3334 11.3858 21.3334 10.6998C21.3223 9.99161 21.1897 9.31665 20.9354 8.69702Z",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5325434d9cfda13c9cf510de226834af.svg";
export { ForwardRef as ReactComponent };